'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_CLASS = 'luna-tabpanel';

var TabPanel = function (_Component) {
  _inherits(TabPanel, _Component);

  function TabPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TabPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabPanel.__proto__ || Object.getPrototypeOf(TabPanel)).call.apply(_ref, [this].concat(args))), _this), _this.node = null, _this.componentDidUpdate = function () {
      _this.checkFocus();
    }, _this.checkFocus = function () {
      if (_this.props.selected && _this.node) {
        _this.node.focus();
      }
    }, _this.handleAccordionChange = function (e) {
      var _this$props = _this.props,
          onAccordionChange = _this$props.onAccordionChange,
          tabId = _this$props.tabId;

      onAccordionChange(tabId, e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TabPanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkFocus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          forceRender = _props.forceRender,
          id = _props.id,
          selected = _props.selected,
          selectedClassName = _props.selectedClassName,
          tabId = _props.tabId,
          toAccordion = _props.toAccordion,
          accordionTitle = _props.accordionTitle,
          onAccordionChange = _props.onAccordionChange,
          onKeyDown = _props.onKeyDown,
          attributes = _objectWithoutProperties(_props, ['children', 'className', 'forceRender', 'id', 'selected', 'selectedClassName', 'tabId', 'toAccordion', 'accordionTitle', 'onAccordionChange', 'onKeyDown']);

      var content = _react2.default.createElement(
        'div',
        Object.assign({}, attributes, {
          className: (0, _classnames2.default)(className, _defineProperty({}, selectedClassName, selected)),
          role: 'tabpanel',
          id: id,
          'aria-labelledby': tabId
        }),
        forceRender || selected ? children : null
      );

      return toAccordion ? _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('luna-accordion', { 'is-open': selected }) },
        _react2.default.createElement(
          'div',
          { className: 'luna-accordion__summary' },
          _react2.default.createElement(
            'h5',
            { className: 'luna-accordion__heading' },
            _react2.default.createElement(
              'button',
              {
                className: 'luna-accordion__action',
                'aria-expanded': selected,
                'aria-controls': id,
                ref: function ref(button) {
                  _this2.node = button;
                },
                onClick: this.handleAccordionChange,
                onKeyDown: onKeyDown
              },
              _react2.default.createElement(
                'span',
                { className: 'luna-accordion__title' },
                accordionTitle
              ),
              !selected && _react2.default.createElement(_.Icon, { name: 'chevron-down' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'luna-accordion__details',
            'aria-hidden': !selected,
            id: id
          },
          content
        )
      ) : content;
    }
  }]);

  return TabPanel;
}(_react.Component);

TabPanel.defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: DEFAULT_CLASS + '--selected',
  style: {}
};
TabPanel.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
  forceRender: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  selectedClassName: _propTypes2.default.string,
  tabId: _propTypes2.default.string
};
exports.default = TabPanel;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tabs/TabPanel.js